var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-chat_sidebar"},[(_vm.activeTab == 'private')?_c('guppy-chat-private-list'):(_vm.activeTab == 'group')?_c('guppy-chat-group-list'):(_vm.activeTab == 'posts')?_c('guppy-chat-post-list'):(_vm.activeTab == 'customer_support')?_c('guppy-chat-support-list'):_vm._e(),_c('guppy-chat-sidebar-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }